import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetPaymentsDataAction } from "../actions/dataActions";
import {useGetAndSet} from "./useGetAndSet";

export const usePaymentsData = (params, dataFresh) => {
  return useGetAndSet("payments", params, createSetPaymentsDataAction, dataFresh)
};
